// extracted by mini-css-extract-plugin
export default {"cardContainer":"PlanProgressCrad_cardContainer__YGvPn","title":"PlanProgressCrad_title__TqYm7","lessons":"PlanProgressCrad_lessons__vVWDp"};